export default "__VITE_ASSET__DBHx9LhX__"